<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <div v-if="csAgentId" class="notification-entry">
        <notification-settings />
      </div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar | filterImage" class="user-avatar" />
          <span>{{displayName}}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown" >
          <el-dropdown-item @click.native="goIndex">{{$t('menuName.home')}}</el-dropdown-item>
          <el-dropdown-item divided @click.native="showPassWordBox">
            <span style="display:block;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">{{$t('common.layOut')}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="旧密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="form.password"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="form.rePassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth">
          <el-input type="password" @input="checkWord" v-model="newpassWord" autocomplete="off"></el-input>
          <div v-show="showError" style="color:red">新密码与确认密码不一致</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePassWord">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { localRead } from "@/utils/tools";
import { updatePassWord } from "@/api/user";
import NotificationSettings from '@/views/customerService/components/NotificationSettings';
export default {
  components: {
    Breadcrumb,
    Hamburger,
    NotificationSettings
  },
  data() {
    return {
      defaultUrl:
        "http://img3.imgtn.bdimg.com/it/u=2519824424,1132423651&fm=26&gp=0.jpg",
      avatar: JSON.parse(localRead(this.$route.query.label + "_sys_userInfo"))
        .imageAddress,
      displayName: JSON.parse(
        localRead(this.$route.query.label + "_sys_userInfo")
      ).displayName,
      dialogFormVisible:false,
      form:{
        password:'',
        rePassword:''
      },
      showError:false,
      newpassWord:'',
      formLabelWidth:'120px'
    };
  },
  created() {
  },
  filters: {
    filterImage(val) {
      if (val != "" && val != null) {
        return val + "?imageView2/1/w/80/h/80";
      } else {
        return require("../../assets/imgAdv.png");
      }
    }
  },
  watch: {
    "$route.query.label": {
      handler(val) {
        this.avatar = JSON.parse(localRead(val + "_sys_userInfo")).imageAddress;
        this.displayName = JSON.parse(localRead(val + "_sys_userInfo")).displayName;
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    csAgentId() {
      return this.$store.getters["customerService/agentId"];
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    goIndex() {
      this.$router.push({ path: '/business/dashboard/list', query: { label: this.$route.query.label } });
    },
    async logout() {
      await this.$store.dispatch("user/logout");

      this.$router.push(`/login`);
      
      location.reload()
    },
    showPassWordBox() {
      this.dialogFormVisible = true
    },
    updatePassWord(){
      if(this.form.password == "" && this.form.rePassword == ""){
        this.$message.error('密码不能为空哦');
        return
      }
      if(this.showError){
         this.$message.error('新密码与确认密码不一致');
        return
      }
      let data = {
        password:this.form.password,
        rePassword:this.form.rePassword,
      }
      updatePassWord(data).then((res)=>{
        if(res.code == 0){
           this.$message({
              message: '密码已修改成功，请重新登录',
              type: 'success'
            });
            setTimeout(()=>{
              this.logout()
            },1000)
            
        }
      })
      this.dialogFormVisible = false
    },
    checkWord(val){
      if(val != this.form.rePassword){
        this.showError = true
      }else{
        this.showError = false
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding-right: 225px;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    .left {
      font-size: 14px;
      margin-right: 20px;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .notification-entry {
      display: flex;
      align-items: center;
      margin-right: 14px;
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
